import './style.css'
import * as THREE from 'three'
// import * as dat from 'dat.gui'
// import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader.js'
// import vertShader from "./shaders/vertShader.glsl"
// import fragShader from "./shaders/fragShader.glsl"
import { loadScene } from "./loading.js"

import {setup} from "./setup"
loadScene()

function main() {

// BASIC SETUP

var {scene,camera,renderer} = setup;

// RENDER LOOP

function render(time)
{   
    renderer.render(scene,camera);
    requestAnimationFrame ( render );
}

requestAnimationFrame ( render );

}

main();




